import { booleanAttribute } from "#ce/utils/props";

export const props = Object.freeze({
  /**
   * The doctor-finder embed uuid → selects the shared omnisearch store instance
   * (one fetch per embed). Placeholder / aria / required-skill / saved searches
   * all arrive through the store's `configure` (called by the wizard), not props.
   */
  uuid: {
    type: String,
    default: undefined,
  },
  /**
   * Accessible label for the accordion branch disclosure toggle (the +/− control
   * that expands a parent specialty's subspecialties). Pass a translated string;
   * `aria-expanded` conveys the open/closed state.
   */
  branchToggleLabel: {
    type: String,
    default: undefined,
  },
  /**
   * Accessible label for the clear (X) button that empties the search field.
   * Pass a translated string.
   */
  clearLabel: {
    type: String,
    default: undefined,
  },
  /**
   * When set, focusing the search input (e.g. tabbing into it) opens the
   * suggestion dropdown immediately, without moving focus into the list — the
   * optional open-on-focus combobox behaviour. Off by default; the arrow keys
   * always open the dropdown regardless.
   *
   * @type {Boolean|String}
   * @default false
   */
  openOnFocus: booleanAttribute(),
});
